import ScatterSwap from 'scatter-swap'

export function reverseHashInt(val) {
  return parseInt(new ScatterSwap(val).reverseHash(), 10)
}
